import { Box, Container, Flex } from "@chakra-ui/react";
import "./App.css";
import Main from "./components/main/index";

function App() {
  return (
    <Container bg={"#f8fafd"} maxW={"container.xl"} minH={"100dvh"} p={"0"}>
      <Flex minH={"100dvh"} justifyContent="center">
        <Box w={"full"} maxW="900px">
          <Main />
        </Box>
      </Flex>
    </Container>
  );
}

export default App;
